import API from '@/api'
/**
 * Contact phone number class
 */
export default class {
  constructor (data) {
    this.phoneNumber = data.phone_number
    this.label = data.label
    this.name = data.name
    this.username = data.username
    this.hasImage = data.has_image
    this.imageUrl = API.baseURLPath(`contacts/${~~data.contact_id}/image`) + `?date=${Date.now()}`
    this.contactID = data.contact_id
  }
}
